/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host([disabled]) {
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--calcite-opacity-disabled);
}

:host([disabled]) *,
:host([disabled]) ::slotted(*) {
  pointer-events: none;
}

:host {
  box-sizing: border-box;
  display: inline-block;
}
:host ::slotted(calcite-tile) {
  margin-block-end: var(--calcite-spacing-px);
  margin-inline-end: var(--calcite-spacing-px);
}

.container {
  display: grid;
  grid-auto-rows: minmax(auto, 1fr);
}

:host([scale=s]) .container {
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
}

:host([scale=m]) .container {
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
}

:host([scale=l]) .container {
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
}

:host([layout=vertical]) .container {
  display: flex;
  flex-direction: column;
}

:host([disabled]) ::slotted([calcite-hydrated][disabled]),
:host([disabled]) [calcite-hydrated][disabled] {
  /* prevent opacity stacking */
  opacity: 1;
}

.interaction-container {
  display: contents;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}